import { parse as cookieParse, serialize as cookieSerialize } from 'cookie';
import { Location } from 'history';
import { range } from 'lodash-es';
import { ANONYMOUS_USERNAME, LOGIN_TITLE, SIGNUP_TITLE } from 'mk/autogenerated/translations/utils.362b1bed39a4b7511501ceccc108b3f8'
import { isAnonymousUsername } from 'mk/bazaar/common/userUtils';
import assetUrl from 'mk/common/assetUrl';
import { logout_url } from 'mk/urls/functions';
import { SexType } from 'mk2/apps/settings/schemas';
import { loginUrl, signupUrl } from 'mk2/apps/users/urls';
import Btn, { BtnType } from 'mk2/components/Btn';
import { hasRoute } from 'mk2/helpers/router';
import { translateMonth } from 'mk2/helpers/timeformat';
import { routes } from 'mk2/router';
import { parse } from 'query-string';
import React from 'react';

export const fixUsername = (username: string): string => {
    return isAnonymousUsername(username) ? ANONYMOUS_USERNAME : username;
};

export const GENERIC_AVATAR_PATH = 'img/avatars/user/no_photo_';

export function getGenericAvatar(size: 50 | 150, sex: SexType): string {
    return `${assetUrl}${GENERIC_AVATAR_PATH}${size}_${sex === SexType.Boy ? 2 : 1}.png`;
}

export function getLastKnownUsernameCookie(): string {
    return cookieParse(document.cookie)._remember || null;
}

export function storeLastKnownUsernameCookie(username: string) {
    document.cookie = cookieSerialize('_remember', username, {
        path: '/',
        maxAge: 400 * 24 * 60 * 60,  // 400 days
    });
}

export function getPregnancyNewsletterCookie(): boolean {
    return Boolean(cookieParse(document.cookie).pregnancyNewsletterSubscribed);
}

export function storeNewsletterClosedCookie() {
    document.cookie = cookieSerialize('pregnancy_newsletter_closed', 'true', {
        path: '/',
        maxAge: 30 * 24 * 60 * 60,  // 30 days
    });
}

export function getPregnancyNewsletterClosedCookie(): boolean {
    return Boolean(cookieParse(document.cookie).pregnancy_newsletter_closed);
}

export function getNewGroupsCookie(): boolean {
    return cookieParse(document.cookie).new_groups === '1';
}

export function getIgnoreOldBrowserWarningCookie(): boolean {
    return Boolean(cookieParse(document.cookie).ignoreOldBrowserWarning);
}

export function storeIgnoreOldBrowserWarningCookie() {
    document.cookie = cookieSerialize('ignoreOldBrowserWarning', 'true', {
        path: '/',
        maxAge: 7 * 24 * 60 * 60,  // 1 week
    });
}

function isUnsuitableRedirectUrl(url: string): boolean {
    return url.startsWith(logout_url())
        || url.indexOf(loginUrl) >= 0
        || url.indexOf('://') >= 0
        || url.indexOf(' ') >= 0;
}

export function isNextPagePWA(location: Location, defaultUrl: string): boolean {
    const redirectTo = (parse(location.search).next as string) || defaultUrl;
    return hasRoute(redirectTo, routes);
}

export function gotoUrlAfterLoginOrSignup(baseUrl: string, location: Location, defaultUrl: string, redirectInPWA: boolean): string {
    let redirectTo = parse(location.search).next as string;

    if (redirectInPWA) {
        baseUrl = '';
    }

    redirectTo = (!redirectTo || isUnsuitableRedirectUrl(redirectTo))
        ? null
        : baseUrl + redirectTo; // FIXME az bude cela app v react, netreba absolut url a bude fungovat success toast

    if (!redirectTo) {
        redirectTo = baseUrl + defaultUrl;  // iframe can be embedded in other pages than www.modrykonik.sk, so we need to use absolute url
    }
    return redirectTo;
}

export function loginSignupTabs(active: string) {
    return [(
        <Btn
            key="signup"
            type={BtnType.Tab}
            label={SIGNUP_TITLE}
            link={signupUrl}
            active={active === 'signup'}
        />), (
        <Btn
            key="login"
            type={BtnType.Tab}
            label={LOGIN_TITLE}
            link={loginUrl}
            active={active === 'login'}
        />)];
}

export function cleanPhoneNumber(prefix, phoneNumber) {
    if (prefix === '+421' || prefix === '+420') {
        return phoneNumber.replace(/\s+/g, '').slice(-9);
    }
    return phoneNumber;
}

export function monthsFrom1980() {
    const options = [];
    const monthsInYear = range(12);
    const yearsFrom1980 = range(1980, new Date().getFullYear() + 2);
    yearsFrom1980.forEach((year) => {
        options.push({value: `${year}`, label: `${year}`});
        monthsInYear.forEach((month) =>
            options.push({value: `${year}-${month + 1}`, label: `${year} - ${translateMonth(month)}`}));
    });
    return options.reverse();
}

export function prettyNumber(phone) {
    if (phone.substring(0, 3) !== '+42') {
        // don't pretty format foreign numbers
        return phone;
    }
    return `${phone.substring(0, 4)} ${phone.substring(4, 7)} ${phone.substring(7, 10)} ${phone.substring(10)}`;
}
